import React, { useState } from "react";
import { Button, Divider } from "antd";
import { Link, withRouter } from "react-router-dom";
import "./landing-page-mobile.style.less";
import RequestFinancingPopupMobile from "./Finance/MobileVersion/RequestFinancingPopupMobile";

const MenuDropdown = (props) => {
  const { menuVisible, setMenuVisible, moveTo } = props;

  const [requestFinance, setRequestFinance] = useState(false);

  const onUserClick = (user) => {
    setMenuVisible(false);
    setRequestFinance(false);
    return props.history.push({
      pathname: "/financing",
      state: {
        userType: user,
      },
    });
  };

  return (
    <>
      {menuVisible && (
        <div className="menu-dropdown">
          <div className="menu-item" onClick={() => moveTo(1)}>
            Features
          </div>
          <Divider />
          <div className="menu-item" onClick={() => setRequestFinance(true)}>
            Financing
          </div>
          <Divider />
          <div className="menu-item" onClick={() => moveTo(2)}>
            What's more
          </div>
          <Divider />
          <div className="login-buttons-wrapper">
            <Link to="/login">
              <Button className="mobile-login-btn">Login</Button>
            </Link>

            <a href="https://safearth.in/signUp/vendor">
              <Button className="mobile-sign-up-btn" type="primary">
                Sign Up
              </Button>
            </a>
          </div>
        </div>
      )}
      <div
        id="overlay"
        style={{ display: menuVisible ? "block" : "none" }}
        onClick={() => setMenuVisible(!menuVisible)}
      />
      <RequestFinancingPopupMobile
        visible={requestFinance}
        setVisible={setRequestFinance}
        onUserClick={onUserClick}
      />
    </>
  );
};

export default withRouter(MenuDropdown);
